import React from "react";
const TextInput = ({ type, label, register, name, required, pattern, maxLength, minLength, errors, value, rows, disabled, fontSize = "14px", padding, customClass, placeholder, onChange, innerRef, }) => {
    const { ref, ...rest } = register(name, {
        required,
        pattern,
        maxLength,
        minLength,
    });
    return (React.createElement("div", { className: "w-full flex flex-col" },
        React.createElement("p", { className: "hidden md:block text-sm text-black font-medium mb-1" }, label),
        React.createElement("input", { ...rest, type: type, ref: (e) => {
                ref(e);
                if (innerRef && e) {
                    innerRef.current = e;
                }
            }, name: name, value: value, maxLength: maxLength?.value, minLength: minLength?.value, onKeyUp: (e) => onChange && onChange(e), placeholder: placeholder, className: `${customClass} ${disabled && "bg-primary/20"}
         w-full text-sm px-3 py-3 placeholder:text-black/40 placeholder:font-light 
         border border-neutralBlue1 outline-none focus:outline-none rounded-md` }),
        errors[name] && (React.createElement("p", { className: "text-xs font-medium text-red-400" }, errors[name].message))));
};
export default TextInput;
